// Simple on/off switches for features that are built but not yet launched to users.
// Flip to true when ready to launch - the underlying routes/components stay intact either way.

// Fortnox invoice creation (single + bulk "Skapa Fortnox-fakturor" entry points).
// The /createfortnoxinvoices route and ManagePayments' Send button still work if navigated to
// directly; this only hides the menu/button entry points that lead a user there.
export const FORTNOX_INVOICE_CREATION_ENABLED = false;
